module.exports = __webpack_public_path__ + "assets/images/feedback_f163ef6adc3f0215dd826dbc29de2f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-six/feedback.png
// module id = 227
// module chunks = 0